import React from 'react'

const InstrumentCalin = () => {
  return (
    <div className='mx-auto p-4'>
      InstrumentCalin
    </div>
  )
}

export default InstrumentCalin
